import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Kontakt = () => {
  const { t } = useLanguage();
  return (
    <div className="min-h-[calc(100vh-200px)] py-10 px-5 bg-slate-100 dark:bg-slate-900">
      <div className="max-w-4xl mx-auto bg-white dark:bg-slate-800 p-6 sm:p-10 rounded-lg shadow-md">
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-800 dark:text-white mb-8 pb-3 border-b-[3px] border-gold">
          {t('kontakt.title')}
        </h1>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            {t('kontakt.subtitle')}
          </h2>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            {t('kontakt.text')}
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            {t('kontakt.contactData')}
          </h2>
          <div className="grid gap-4 sm:grid-cols-2">
            <div className="p-4 bg-slate-50 dark:bg-slate-700/50 rounded-lg">
              <strong className="text-slate-800 dark:text-white block mb-1">{t('kontakt.owner')}:</strong>
              <p className="text-slate-600 dark:text-slate-300 m-0">Timm Buse</p>
            </div>
            <div className="p-4 bg-slate-50 dark:bg-slate-700/50 rounded-lg">
              <strong className="text-slate-800 dark:text-white block mb-1">{t('kontakt.address')}:</strong>
              <p className="text-slate-600 dark:text-slate-300 m-0">
                Meiereistrasse 6<br />
                24960 Munkbrarup
              </p>
            </div>
            <div className="p-4 bg-slate-50 dark:bg-slate-700/50 rounded-lg sm:col-span-2">
              <strong className="text-slate-800 dark:text-white block mb-1">{t('kontakt.email')}:</strong>
              <p className="text-slate-600 dark:text-slate-300 m-0">
                <a href="mailto:info@tmk-it.de" className="text-gold hover:underline">info@tmk-it.de</a>
              </p>
            </div>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            {t('kontakt.inquiries')}
          </h2>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            {t('kontakt.inquiriesText')}{' '}
            <a href="mailto:info@tmk-it.de" className="text-gold hover:underline">info@tmk-it.de</a>.
          </p>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            {t('kontakt.inquiriesText2')}
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            {t('kontakt.privacy')}
          </h2>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            {t('kontakt.privacyText')}{' '}
            <a href="/datenschutz" className="text-gold hover:underline">{t('kontakt.privacyLink')}</a>{' '}
            {t('kontakt.privacyText2')}
          </p>
        </section>
      </div>
    </div>
  );
};

export default Kontakt;
